import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

import device from "../utils/device"

import Hamburger from "./hamburger"

const HamburgerWrapper = styled.div`
  @media ${device.laptop} {
    display: none;
    background: red;
  }
`

const NavItem = styled(Link)`
  font-family: 'Trajan Pro 3';
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;

  width: 100%;
  padding: 24px 0;
  border-top: solid 1px #fff;
  border-bottom: solid 1px #fff;
  border-top-color: rgb(255, 255, 255, 0.05);
  border-bottom-color: rgb(255, 255, 255, 0.05);
  
  @media ${device.laptop} {
    width: auto;
    margin-right: 64px;
    padding: 0;
    
    border-top: none;
    border-bottom-color: rgb(255, 255, 255, 0);
    transition: border-bottom-color .3s;

    &:hover {
      border-bottom-color: rgb(255, 255, 255, 1);
    },
  }
`
const NavList = styled.nav`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100vw;
  height: ${props => props.height || "auto"};
  overflow: hidden;

  background-color: #000;
  transition: height 0.3s;

  @media ${device.laptop} {
    position: relative;
    top: 0;
    width: auto;
    height: auto;
    flex-direction: row;
  }
`

class Navigation extends React.Component {
  state = {
    menuOpen: false,
  }

  handleMenuClick() {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render() {
    return (
      <>
        <HamburgerWrapper>
          <Hamburger
            open={this.state.menuOpen}
            onClick={() => this.handleMenuClick()}
            color="white"
          />
        </HamburgerWrapper>
        <NavList height={this.state.menuOpen ? "294px" : "0"}>
          <NavItem to="/">Home</NavItem>
          <NavItem to="/#realizacje">Realizacje</NavItem>
          <NavItem to="/#kontakt">Kontakt</NavItem>
        </NavList>
      </>
    )
  }
}

export default Navigation
